var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',[_vm._v("Copyright © 2023")]),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }